import { FC } from 'react';

import { formatMoney } from '../../../shared/functions/formatter';
import { CardTitle, Notice } from '../../../ui';
import { rangeText } from './types';

type BundlePricingSummaryProps = {
  componentsMin: number;
  componentsMax: number;
  effectivePrice: number;
  savingMin: number;
  savingMax: number;
  groupsComplete: boolean;
  savingWarning: boolean;
};

/** The editor's live pricing: the eligible range, the price and the saving. */
const BundlePricingSummary: FC<BundlePricingSummaryProps> = ({
  componentsMin,
  componentsMax,
  effectivePrice,
  savingMin,
  savingMax,
  groupsComplete,
  savingWarning,
}) => (
  <section className="discountEditorSection">
    <CardTitle level={3}>Pricing</CardTitle>
    <dl className={'discountPricing' + (groupsComplete ? ' discountPricingPriced' : '')}>
      <div>
        <dt>Eligible regular price</dt>
        <dd className="money">{rangeText(componentsMin, componentsMax)}</dd>
      </div>
      <div>
        <dt>Bundle price</dt>
        <dd className="money">{formatMoney(effectivePrice)}</dd>
      </div>
      <div className="discountPricingSave">
        <dt>Customer saves</dt>
        <dd className="money">{rangeText(savingMin, savingMax)}</dd>
      </div>
    </dl>
    {savingWarning && (
      <Notice variant="warning" className="discountWarn">
        Some combinations do not save customers money. Lowest regular price {formatMoney(componentsMin)} - Bundle price{' '}
        {formatMoney(effectivePrice)}
      </Notice>
    )}
  </section>
);

export default BundlePricingSummary;
